import { doRequest } from '@r1-frontend/do-request/index';
import { IStatusPayment } from '@r1-frontend/api-domru/api-pay/v1/payment/dto/IStatusPayment';
import { getPaymentStatusAuth, getPaymentStatusUnAuth } from '@r1-frontend/api-domru/api-pay/v1/payment/status';

import { getInfoByPaymentStatus, TPaymentStatus } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/actions';
import { selectCardPaySum } from '~/src/features/payments-abn/components/SeasonTicketPayment/store/selectors/selectPaymentSum';
import { pushDataLayer } from '~/src/features/payments-abn/helpers/pushDataLayer';
import { EPaymentTypeIds, IPaymentResult, setPaymentResult } from '~/src/features/payments-abn/store/actionCreators';
import { updateTransaction } from '~/src/features/payments-abn/store/actions';
import { updateOffer } from '~/src/features/specialOffersContainer/store/actions/thunk';
import { selectOffer } from '~/src/features/specialOffersContainer/store/selectors';
import { TAppThunkDispatch, TGetState } from '~/src/store';
import { getClientAll } from '~/src/store/actions/auth/getClientAll';

// проверка статуса платежа после фрейма банка
const checkPaymentStatus = (order: string, transaction?: string, transactionSum?: string) => {
    return async(dispatch: TAppThunkDispatch, getState: TGetState): Promise<void> => {
        const state = getState();

        const {
            auth: { isAuth },
            city: { provider: { providerId } },
            payment: { paymentData: { paymentSum, isConnectAutoPay }, isSaveCard, result, paymentTypeId },
        } = state;
        const popupOffer = selectOffer(state);
        const cardPaymentSum = selectCardPaySum(state);

        const resp = await doRequest.apiPay<IStatusPayment>(
            isAuth
                ? getPaymentStatusAuth(providerId, order)
                : getPaymentStatusUnAuth(providerId, order),
        );
        // у покупки абонемента своя обработка статуса
        if (paymentTypeId === EPaymentTypeIds.WHOLESALE) {
            const actionParams: TPaymentStatus = resp.isSuccess
                ? {
                    isSuccess: true,
                    payStatus: resp.payload.payStatus,
                }
                : {
                    isSuccess: false,
                };

            dispatch(getInfoByPaymentStatus(actionParams));
        } else {
            const currentKey: keyof Pick<IPaymentResult, 'isPayCardSuccess' | 'isAutoPaySuccess'> = cardPaymentSum ? 'isPayCardSuccess' : 'isAutoPaySuccess';

            pushDataLayer('click payment by new card', resp.isSuccess ? 'success' : 'error');

            let isOpenPopup = !!cardPaymentSum || isConnectAutoPay || isSaveCard;

            if (resp.isSuccess && transaction && transactionSum) {
                const isTransactionPayed = paymentSum >= Number(transactionSum);

                dispatch(updateTransaction({
                    id: transaction,
                    payed: isTransactionPayed,
                }));

                if (popupOffer && isTransactionPayed) {
                    isOpenPopup = false;
                    dispatch(updateOffer());
                }
            }

            const respData: IPaymentResult = {
                ...result,
                frameUrl: '',
                payStatus: resp.isSuccess ? resp?.payload.payStatus : undefined,
                [currentKey]: resp.isSuccess,
                isOpenPopup,
            };

            dispatch(setPaymentResult(respData));
            dispatch(getClientAll());
        }
        };
    };

export default checkPaymentStatus;
